import React from "react";
import { Box, Grid, Stack } from "@mui/material";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import styled from "styled-components";
import TicketsBreakdownChart from "src/components/tickets-breakdown-chart";
import NoDataPlaceholder from "src/components/no-data-placeholder";

const Title = styled.h4`
    font-size: 12px;
    font-weight: 300;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
`;

const Count = styled.span`
    font-size: 12px;
    font-weight: 300;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
`;

const TicketsBreakdown = ({ data, dataExpanded, isBreakdownExpanded, issuesOrPoints, context }) => {
    if (!data) return <NoDataPlaceholder />;
    if (data && data.length === 0) return <NoDataPlaceholder variant="tickets" />;

    const issues = issuesOrPoints || (context && context["issues-points"]);
    const defaultTypes = ["Subtask", "Task", "Bug", "Feature", "Epic", "Other"];
    const types = dataExpanded.reduce((acc, item) => {
        item.issues.forEach((issue) => {
            acc[issue.type] = (acc[issue.type] || 0) + issue.value[issues];
        });
        return acc;
    }, {});
    while (Object.keys(types).length < 6) {
        const type = defaultTypes.shift();
        types[type] = 0;
    }
    if (isBreakdownExpanded === false) {
        return (
            <Box
                sx={{
                    width: "100%",
                    height: "100%",
                    overflowY: "auto",
                    paddingBottom: "12px",
                    marginBottom: "12px",
                }}
            >
                <Grid container direction="row" pt={6}>
                    {data.map((item) => {
                        return (
                            <Grid item md={2} style={{ width: "100%" }} p={1} key={item.status}>
                                <Stack
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    style={{ width: "100%" }}
                                >
                                    <Stack
                                        direction="row"
                                        alignItems="center"
                                        style={{ width: "60%" }}
                                    >
                                        <LocalOfferOutlinedIcon
                                            style={{ width: "20%", opacity: "0.2" }}
                                        />
                                        <Title style={{ fontWeight: "400" }}>{item.status}</Title>
                                    </Stack>
                                    <Title>{item.total[issues]}</Title>
                                </Stack>
                                <Box style={{ height: "23px" }}>
                                    <TicketsBreakdownChart
                                        issues={item.issues}
                                        types={types}
                                        issuesOrPoints={issues}
                                    />
                                </Box>
                            </Grid>
                        );
                    })}
                </Grid>
            </Box>
        );
    }
    if (isBreakdownExpanded === true) {
        return (
            <Box
                sx={{
                    width: "100%",
                    height: "100%",
                    overflowY: "auto",
                    paddingBottom: "12px",
                    marginBottom: "12px",
                }}
            >
                <Grid container direction="row" pt={0}>
                    {dataExpanded.map((item) => {
                        return (
                            <Grid item md={2} key={item.status}>
                                <Stack direction="column" style={{ width: "100%" }} p={1}>
                                    <Stack
                                        direction="row"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        style={{ width: "100%" }}
                                    >
                                        <Stack
                                            direction="row"
                                            alignItems="center"
                                            style={{ width: "60%" }}
                                        >
                                            <LocalOfferOutlinedIcon
                                                style={{ width: "20%", opacity: "0.2" }}
                                            />
                                            <Title style={{ fontWeight: "400" }}>
                                                {item.status}
                                            </Title>
                                        </Stack>
                                        <Count>{item.total[issues]}</Count>
                                    </Stack>
                                    <Box style={{ height: "23px" }}>
                                        <TicketsBreakdownChart
                                            issues={item.issues}
                                            types={types}
                                            issuesOrPoints={issues}
                                        />
                                    </Box>
                                </Stack>
                            </Grid>
                        );
                    })}
                </Grid>
            </Box>
        );
    }
    return null;
};
export default TicketsBreakdown;
